<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <div class="row">
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </div>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Search:">
              <b-form-input v-model="formFilters.search" />
            </b-form-group>
            <!--<b-form-group label="Show Closed:">
              <b-v-select
                v-model="formFilters.showOpen"
                :options="closedFilterOpts"
              />
            </b-form-group>-->
            <b-form-group label="Status:" v-if="formFilters.showOpen != 1">
              <b-v-select
                v-model="formFilters.status"
                :options="statusListClosed"
              />
            </b-form-group>
            <b-form-group label="Status:" v-else-if="formFilters.showOpen == 1">
              <b-v-select
                v-model="formFilters.status"
                :options="statusListOpen"
              />
            </b-form-group>
            <b-form-group label="Priority:">
              <b-v-select
                v-model="formFilters.priority"
                :options="priorityFilter"
              />
            </b-form-group>
            <b-form-group label="Type:">
              <b-v-select
                v-model="formFilters.type"
                :options="typeFilter"
              />
            </b-form-group>

            <b-form-group label="Project:" label-for="item-projectId" v-if="projectsFilter.length">
              <b-v-select
                v-model="formFilters.projectId"
                :searchable="true"
                :options="projectsFilter"
              />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col-auto">
            <h1 class="header-title">
              Customer Tickets
            </h1>
          </div>
          <div class="col">
            <div class="form-row" style="width: 350px">
              <b-form-group class="m-0">
                <b-input-group prefix="Search:">
                  <b-form-input v-model="formFilters.search" />
                </b-input-group>
              </b-form-group>
              <b-form-group class="m-0">
                <b-button variant="secondary" @click="formFilters.status = ''; applyFilters();
                    loadItems();"><i class="fa fa-search"></i></b-button>
              </b-form-group>
            </div>
          </div>
          <div class="col-auto">
            <!-- <b-button
            v-if="formFilters.status == '' &&formFilters.search == '' && formFilters.priority == -1 && formFilters.showOpen == 1 && $store.getters['account/hasUserRole']('superadmin')"
              @click="switchSortView"
              class="btn btn-info mr-2"
            >
              <i class="mr-2 fa fa-sort" />
              Sort View
            </b-button>
            <b-button
              @click="saveReOrder"
              v-if="reOrderView && $store.getters['account/hasUserRole']('superadmin')"
              class="btn btn-success mr-2"
            >
              <i class="mr-2 fa fa-save" />
              Save Sorting
            </b-button> -->

            <b-form-select
              v-model="pagination.sortBy"
              @change="loadItems"
              class="d-inline w-auto mr-2"
              :options="posSortBy"
            />
            <b-button variant="primary" @click="showFilters = !showFilters" v-if="!reOrderView">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="m-0 bg-white mb-5" v-if="reOrderView">
        <table class="table b-table table-striped table-bordered border b-table-fixed">
          <thead class="thead-dark">
            <tr>
              <!-- <th scope="col">#</th> -->
              <th scope="col">Ticket</th>
              <th scope="col">Name</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <draggable v-model="items" tag="tbody" @change="ticketSorted"
          :group="{name: 'ticketSort', pull: 'clone'}">
            <tr v-for="(item, index) in items" :key="item.id">
              <!-- <td scope="row">{{index}}</td> -->
              <td>{{ item.ticketCustomerNumber }}</td>
              <td>{{ item.name }}</td>
              <td>
                <div>
                  <span class="badge badge-warning" v-if="item.status == 'triage'">Triage</span>
                  <span class="badge badge-secondary" v-else-if="item.status == 'backlog'">Draft</span>
                  <span class="badge badge-primary" v-else-if="item.status == 'unstarted'">Open</span>
                  <span class="badge badge-info" v-else-if="item.status == 'started'">In Progress</span>
                  <span class="badge badge-danger" v-else-if="item.status == 'canceled'">Cancelled</span>
                  <span class="badge badge-success" v-else>Completed</span>
                </div>
              </td>
            </tr>
          </draggable>
        </table>
    </div>
    <div v-else>
      
      <b-nav tabs>
        <b-nav-item :active="itemsFilters.showOpen == 1" @click="itemsFilters.showOpen = 1;formFilters.showOpen = 1; loadItems()">Active</b-nav-item>
        <b-nav-item :active="itemsFilters.showOpen == 0" @click="itemsFilters.showOpen = 0;formFilters.showOpen = 0; loadItems()">Closed</b-nav-item>
      </b-nav>
    <TableListing
      class="mb-0 mt-0"
      :loading-page="loadingItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(modifiedDateTimeUtc)="data">
        <span
          v-if="
            data.item.modifiedDateTimeUtc &&
              !data.item.modifiedDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.modifiedDateTimeUtc + 'Z') | moment('MMMM Do, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.modifiedDateTimeUtc">{{
          data.item.modifiedDateTimeUtc | moment('MMMM Do, h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(createDateTimeUtc)="data">
        <span
          v-if="
            data.item.createDateTimeUtc &&
              !data.item.createDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.createDateTimeUtc + 'Z') | moment('MMMM Do YYYY h:mm a')
          }}</span
        >
        <span v-else-if="data.item.createDateTimeUtc">{{
          data.item.createDateTimeUtc | moment('MMMM Do YYYY h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(needsBillOfLading)="data">
        <span v-if="data.item.needsBillOfLading">Yes</span>
        <span v-else>No</span>
      </template>
      <template v-slot:cell(projectId)="data">
        <span>{{ myProjects.filter(a => a.id == data.item.projectId).length > 0 ? myProjects.find(a => a.id == data.item.projectId).name : '-' }}</span>
      </template>
      <template v-slot:cell(isOpen)="data">
        <span class="badge badge-warning" v-if="data.item.isOpen">Open</span>
        <span class="badge badge-success" v-else>Closed</span>
      </template>
      <template v-slot:cell(status)="data">
        <span class="badge badge-secondary" v-if="data.item.subStatus && data.item.subStatus != ''">{{data.item.subStatus}}</span>
        <div v-else>
          <span class="badge badge-warning" v-if="data.item.status == 'triage'">Triage</span>
          <span class="badge badge-warning" v-else-if="data.item.status == 'backlog'">Draft</span>
          <span class="badge badge-primary" v-else-if="data.item.status == 'unstarted'">Open</span>
          <span class="badge badge-info" v-else-if="data.item.status == 'started'">In Progress</span>
          <span class="badge badge-danger" v-else-if="data.item.status == 'canceled'">Cancelled</span>
        <span class="badge badge-success" v-else>Completed</span>
        </div>
        <b-input-group prepend="To:" size="sm" class="mt-1" v-if="data.item.submittedBy == 'Customer' && data.item.subStatus == ''">
          <b-form-select
            v-model="data.item.status"
            :options="statusList"
            @change="changedStatus(data.item.id, data.item.status)"
          ></b-form-select>
        </b-input-group>
      </template>
      <template v-slot:cell(type)="data">
        <div>
          <b-form-select
            v-model="data.item.type"
            :options="typeList"
            @change="changedType(data.item.id, data.item.type)"
          ></b-form-select>
        </div>
      </template>
      <template v-slot:cell(priority)="data">
        <div v-if="$store.getters['account/hasUserRole']('superadmin')">
          <b-form-select
          :disabled="true"
            v-model="data.item.priority"
            :options="priorityList"
            @change="changedPriority(data.item.id, data.item.priority)"
          ></b-form-select>
        </div>
        <div v-else>
          <span class="badge badge-primary" v-if="data.item.priority == 0">Not Set</span>
          <span class="badge badge-secondary" v-else-if="data.item.priority == 1">Low</span>
          <span class="badge badge-info" v-else-if="data.item.priority == 2">Medium</span>
          <span class="badge badge-warning" v-else-if="data.item.priority == 3">High</span>
          <span class="badge badge-danger" v-else-if="data.item.priority == 4">Urgent</span>
          <span class="badge badge-primary" v-else>Not Set</span>
        </div>
      </template>
      <template v-slot:cell(name)="data">
        <div>
          <span v-if="data.item.unreadMessages" class="badge badge-warning mr-2" v-b-tooltip.hover title="Unread Messages">{{data.item.unreadMessages}}</span>
          <span>{{ data.item.name }}</span>
        </div>
      </template>
      <template v-slot:cell(ticketNumber)="data">
        <button
          type="link"
          class="btn ml-1"
          :class="{'btn-primary': data.item.isOpen, 'btn-secondary': !data.item.isOpen}"
          @click="OpenItem(data.item)"
        >
          {{data.item.ticketNumber}}
        </button>
      </template>
    </TableListing>
    </div>
  </section>
</template>

<script>
import draggable from "vuedraggable";
import TableListing from '@/views/components/TableListing.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Support.Tickets.Index',
  mixins: [crudMixinGen('support-ex-tickets'), myCommonDataMixin],
  components: {
    draggable,
    TableListing
  },

  data: () => ({
    posSortBy: [
      { value: 'Priority', text: 'By Priority' },
      { value: 'ModifyDateTimeUtc', text: 'Last Updated' },
      { value: 'Status', text: 'Ticket Status' }
    ],
    usersAll: [],
    reOrderView: false,
    thereWasChanged: false,
    closedFilterOpts: [
      { value: 1, text: 'Only Active' },
      { value: 0, text: 'All' }
    ],
    statusList: [
      { value: 'unstarted', text: 'Open' },
      { value: 'started', text: 'In Progress' },
      { value: 'canceled', text: 'Canceled' },
      { value: 'completed', text: 'Completed' },
    ],
    statusListOpen: [
      { value: 'triage', text: 'Triage' },
      { value: 'backlog', text: 'Draft' },
      { value: 'unstarted', text: 'Open' },
      { value: 'started', text: 'In Progress' }
    ],
    statusListClosed: [
      { value: 'canceled', text: 'Canceled' },
      { value: 'completed', text: 'Completed' },
    ],
    priorityFilter: [
      { value: -1, text: 'All' },
      { value: 1, text: 'Low' },
      { value: 2, text: 'Medium' },
      { value: 3, text: 'High' },
      { value: 4, text: 'Urgent' },
    ],
    priorityList: [
      //{ value: -1, text: 'All' },
      { value: 1, text: 'Low' },
      { value: 2, text: 'Medium' },
      { value: 3, text: 'High' },
      { value: 4, text: 'Urgent' },
    ],
    typeList: [
      { value: 'Bug Report', text: 'Bug Report' },
      { value: 'New Feature', text: 'New Feature Suggestion' },
      { value: 'Feature Improvement', text: 'Feature Improvement' },
      { value: 'General Support', text: 'General Support' },
      { value: 'Reservations', text: 'Reservations' },
    ],
    typeFilter: [
      { value: '', text: 'All' },
      { value: 'Bug Report', text: 'Bug Report' },
      { value: 'New Feature', text: 'New Feature Suggestion' },
      { value: 'Feature Improvement', text: 'Feature Improvement' },
      { value: 'General Support', text: 'General Support' },
      { value: 'Reservations', text: 'Reservations' },
    ],
    fields: [
      { key: 'ticketNumber', label: 'Ticket Number', sortable: false },
      { key: 'name', label: 'Name', sortable: false },
      { key: 'status', label: 'Status', sortable: false },
      { key: 'modifiedDateTimeUtc', label: 'Last Updated', sortable: false },
      { key: 'type', label: 'Type', sortable: false },
      { key: 'projectId', label: 'Project', sortable: false },
      { key: 'priority', label: 'Priority', sortable: false },
      { key: 'createDateTimeUtc', label: 'Created At', sortable: false },
      { key: 'userFullName', label: 'By Customer', sortable: false },
      //{ key: 'id', label: 'Action', sortable: false }
    ]
  }),

  computed: {
    posBy: {
      get() {
        let arrs = [];
        arrs.push({ value: '-1', text: 'Any User' });
        if(this.usersAll && this.usersAll.length>0) {
          this.usersAll.forEach(itm => {
            arrs.push({
              value: itm.id,
              text: itm.fullName + ' (' + itm.email + ')'
            });
          });
        }
        return arrs;
      },
      set(old, val) {}
    },
    maxOrderByRank: {
      get() {
        let maxItm = 0;
        this.items.forEach((itm) => {
          if(itm.orderByRank > maxItm) {
            maxItm = itm.orderByRank;
          }
        })
        return maxItm;
      },
      set(val) {

      }
    }
  },
  mounted() {
    if(this.$store.getters['account/hasUserRole']('superadmin')) {
      //this.loadUsers();
    }
    this.formFilters.externalSubmits = 'external-only';
    this.itemsFilters.externalSubmits = 'external-only';
    this.loadItems();
  },

  methods: {
    changedStatus(ticket, status) {
      if(ticket != null) {
        this.$http
          .post('/api/common/tickets/changeStatus/' + ticket.id + '/'+ status)
          .then(resp => {
            ticket.status = status;
              this.$swal('Ticket status updated!');
          })
          .catch(err => {});
      }
    },
    // loadUsers(hnl = () => {}) {
    //   this.$http
    //     .get('/api/userspublic')
    //     .then(resp => {
    //       console.log('get userspublic', resp.data);
    //       this.usersAll = resp.data;
    //       hnl();
    //     })
    //     .catch(err => {});
    // },
    ticketSorted(event) {
      if(event.moved != null) {
        let newIndex = event.moved.newIndex;
        let oldIndex = event.moved.oldIndex;
        let item = event.moved.element;
        let itemAbove = this.items[newIndex-1];
        let itemBelow = this.items[newIndex+1];
        this.items.forEach((itm, index) => {
          itm.orderByRank = (this.items.length - index);
          this.thereWasChanged = true;
        })
      }
    },
    switchSortView() {
      if(this.reOrderView) {
        if(this.thereWasChanged) {
          this.saveReOrder();
        } else {
          this.reOrderView = false;
        }
      } else {
        this.reOrderView = true;
      }
    },
    saveReOrder() {
      let arrs = []
      this.items.forEach((itm, index) => {
        arrs.push({
          id: itm.id,
          orderByRank: itm.orderByRank
        })
      })
        this.$http
          .post('/api/common/tickets/reorder/', {
            items: arrs
          })
          .then(resp => {
            this.reOrderView = false;
            this.loadItems();
            this.thereWasChanged = false;
          })
          .catch(err => {});
    },
    changedPriority(id, priority) {
      let itm = this.items.find(a => a.id == id);
      if(itm != null) {
        itm.priority = priority;
        this.$http
          .post('/api/common/tickets/changePriority/' + id + '/'+ priority)
          .then(resp => {
            this.loadItems();
          })
          .catch(err => {});
      }
    },
    changedType(id, type) {
      let itm = this.items.find(a => a.id == id);
      if(itm != null) {
        itm.type = type;
        this.$http
          .post('/api/common/tickets/changeType/' + id, JSON.stringify(type), {
            headers: { 'Content-Type': 'application/json' }
          })
          .then(resp => {
            if(this.itemsFilters.type) {
              this.loadItems();
            }
          })
          .catch(err => {});
      }
    },
    OpenItem(item) {
      this.$router.push({
        name: 'Support.Tickets.View',
        params: { id: item.id }
      });
    }
  }
};
</script>

